export function controlledCustomMetaCount(aggregation, value) {
  if(!aggregation) return null

  const bucket = aggregation?.buckets?.find(candidate => candidate.key === value)

  if(bucket) return bucket.doc_count

  // Missing buckets are true zeroes only when Elasticsearch returned the full
  // terms aggregation. Otherwise this particular value's count is unknown.
  return aggregation?.sum_other_doc_count > 0 ? null : 0
}
